import { useState } from "react";
import "./FAQs.css";

const FAQs = ({ data }: { data: any }) => {
  // Track which FAQ items are open (allows multiple open items across columns).
  const [openFaqs, setOpenFaqs] = useState<Record<string, boolean>>({});

  return (
    <section className="faqs-section max-w-screen-xl mx-auto px-4 py-10">
      <h2 className="faqs-heading">{data?.sectionTitle}</h2>
      <div className="faqs-container">
        {data?.columns.map((column: any, index: number) => {
          return (
            <div className="faqs-column" key={`${index}-column`}>
              <div className="faqs-scrollable">
                {column?.faqs.map((item: any, idx: number) => {
                  const faqId = `${index}-${idx}`;
                  const isOpen = Boolean(openFaqs[faqId]);

                  return (
                    <div key={idx} className="faq-item">
                      <div
                        className={`faq-question-wrapper${isOpen ? " open" : ""}`}
                        role="button"
                        tabIndex={0}
                        aria-expanded={isOpen}
                        aria-controls={`faq-answer-${faqId}`}
                        onClick={() =>
                          setOpenFaqs((prev) => ({
                            ...prev,
                            [faqId]: !prev[faqId],
                          }))
                        }
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            setOpenFaqs((prev) => ({
                              ...prev,
                              [faqId]: !prev[faqId],
                            }));
                          }
                        }}
                      >
                        <div className="faq-question">
                          <span className="faq-text">{item.question}</span>
                          <span className="faq-icon"></span>
                        </div>
                        <div id={`faq-answer-${faqId}`} className="faq-answer">
                          {item.answer}
                        </div>
                      </div>
                      <hr className="faq-divider" />
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FAQs;
